import { BaseModel, Attribute } from './base-model'

export class Video extends BaseModel {
  public id       : number
  public lectureId: number
  public name     : string
  @Attribute(Date) public startedAt: Date
  @Attribute(Date) public endedAt: Date
  public url: string
  public youtubeId: string
  public dasId: string
  public eventPublished: boolean
}



// WEBPACK FOOTER //
// ./src/models/video.ts